<template>
  <div :id="partId" class="part-banner">
    <div ref="kvWrap" class="part-banner-kv"></div>
    <div :class="['part-banner-text', { 'js-trigger__text-in': isLottiePlayed }]">
      <div class="part-banner-title">{{ $t(`${partId}-banner-1`) }}</div>
      <div class="part-banner-title">{{ $t(`${partId}-banner-2`) }}</div>
      <div class="part-banner-description">{{ $t(`${partId}-banner-3`) }}</div>
    </div>
  </div>
</template>

<script>
import lottie from 'lottie-web/build/player/lottie_svg.min';
import ScrollMagic from 'scrollmagic';
import Controller from '../../util/scrollMagic';
import personality from './js/personality.json';
import highEfficiency from './js/high-efficiency.json';
import fluent from './js/fluent.json';
import photography from './js/photography.json';
import privacy from './js/privacy.json';
let aniData = {
  personality,
  highEfficiency,
  fluent,
  photography,
  privacy
};
export default {
  inject: ['vm'],
  props: {
    partId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isLottiePlayed: false
    };
  },
  mounted() {
    if (this.vm.isMobile) {
      this.initSceneMobile();
    } else {
      this.initScene();
    }
  },
  methods: {
    initSceneMobile() {
      this.scene = new ScrollMagic.Scene({
        duration: 300,
        triggerElement: `#${this.partId}`,
        triggerHook: 1,
        offset: window.innerHeight / 2
      }).addTo(Controller);
      if (location.href.indexOf('localhost:800') > -1) return;
      this.scene.on('start', () => {
        this.isLottiePlayed = true;
      });
      this.scene.on('end', () => {
        this.playAni();
      });
    },
    initScene() {
      this.scene = new ScrollMagic.Scene({
        duration: 300,
        triggerElement: `#${this.partId}`,
        triggerHook: 1,
        offset: screen.availHeight / 3
      }).addTo(Controller);
      if (location.href.indexOf('localhost:800') > -1) return;
      this.scene.on('start', () => {
        this.playAni();
      });
    },
    playAni() {
      if (this.$refs.kvWrap.children.length) return;
      let anim = lottie.loadAnimation({
        container: document.querySelector(`#${this.partId} .part-banner-kv`),
        renderer: 'svg',
        loop: false,
        autoplay: true,
        animationData: aniData[this.partId]
      });
      anim.addEventListener('complete', () => {
        console.log('in complete', new Date().getTime(), anim.getDuration(true));
        !this.vm.isMobile && (this.isLottiePlayed = true);
        this.scene.destroy();
        this.scene = null;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
#privacy {
  .part-banner-title {
    color: #ffffff;
  }
  .part-banner-description {
    color: rgba($color: #ffffff, $alpha: 0.55);
  }
}
.part-banner {
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.part-banner-text {
  margin-top: 72px;
}
.part-banner-title {
  font-variation-settings: 'wght' 1000;
  font-size: 96px;
  line-height: 101px;
  text-align: center;
  opacity: 0;
}

.part-banner-description {
  font-size: 14px;
  line-height: 190%;
  color: rgba($color: #000000, $alpha: 0.55);
  padding-top: 24px;
  width: 432px;
  text-align: center;
  opacity: 0;
  margin: 0 auto;
  font-variation-settings: 'wght' 550;
}

.part-banner-kv {
  // width: 800px;
  // height: 640px;

  width: 250px;
  height: 200px;
}
.part-banner-kv--end {
  width: 250px;
  height: 200px;
  transition: all 0.3s cubic-bezier(0.17, 0.09, 0, 1);
}
.part-banner-title ~ .part-banner-title {
  padding-top: 16px;
}
html[lang|='zh'] {
  .part-banner-title {
    font-size: 72px;
    line-height: 83px;
  }
  .part-banner-title ~ .part-banner-title {
    padding-top: 0px;
  }
}
@media only screen and (min-width: 1950px) {
  .part-banner-kv {
    width: 317px;
    height: 255px;
  }
  .part-banner-text {
    margin-top: 62px;
  }
}
@media only screen and (max-width: 734px) {
  html[lang] {
    .part-banner {
      padding-top: 50px;
      flex-direction: column-reverse;
      align-items: flex-start;
      justify-content: flex-start;
      height: auto;
    }
    .part-banner-text {
      margin-top: 0;
    }
    .part-banner-title {
      padding-left: 20px;
      font-size: 50px;
      line-height: 60px;
      text-align: left;
    }

    .part-banner-description {
      padding-top: 30px;
      line-height: 23px;
      width: 74.133%;
      text-align: left;
      padding-left: 20px;
      margin: 0;
    }

    // .part-banner-title ~ .part-banner-title {
    //   padding-top: 0px;
    // }

    .part-banner-kv {
      width: 100vw;
      height: 330px;
    }
  }
}
</style>
